export const formatCurrency = (amount, currency = "USD", locale) => {
  const value = Number(amount);
  if (Number.isNaN(value)) return "—";
  const loc = locale ? locale.replace("_", "-") : undefined;
  const cur = currency || "USD";
  try {
    return new Intl.NumberFormat(loc, {
      style: "currency",
      currency: cur,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (e) {
    try {
      return new Intl.NumberFormat(loc, {
        style: "currency",
        currency: cur,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e2) {
      return `${cur} ${value.toFixed(2)}`.trim();
    }
  }
};
